module.exports = __webpack_public_path__ + "static/media/peroni_formati_2.c92bf8ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/peroni_formati_2.jpg
// module id = 809
// module chunks = 0